import Omy from "./Omy";
import { OMY_SETTING, OmyConst } from "./OmyConst";
import Stats from "../lib/Stats";
import { Timer } from "eventemitter3-timer";

export default class OmyGame extends PIXI.Application {
  constructor(config, customStage = null) {
    super(config);

    if (!Array.isArray) {
      Array.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
      };
    }
    globalThis.__PIXI_APP__ = this;

    // this.renderer.view.style.position = "absolute";
    // this.renderer.view.style.display = "block";
    // this.renderer.autoDensity = true;
    this._gamePaused = false;

    this._emit = new OmyConst.Emit();
    this.stage = customStage || this.stage || Omy.add.container();

    /** @type {Array.<Function>} */
    this._updateList = [];

    Omy.WIDTH = config.width;
    Omy.HEIGHT = config.height;
    Omy.isDesktop = !PIXI.utils.isMobile.any && !OMY_SETTING.ONLY_PORT_MODE;
    Omy.isRealDesktop = !PIXI.utils.isMobile.any;

    Omy.game = this;
    Omy.checkURL();
    Omy.init();

    if (Omy.showFPS) {
      this._stats = new Stats();
      this._stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
      document.body.appendChild(this._stats.dom);
    }

    document.oncontextmenu = document.body.oncontextmenu = function(event) {
      return false;
    };

      this._ticker = PIXI.Ticker.shared;
      this._ticker.autoStart = false;
      this._ticker.maxFPS = OMY_SETTING.RENDER_FPS;
      this._ticker.minFPS = OMY_SETTING.RENDER_FPS;
      this._ticker.add(this._animate, this);

    this.isRunning = false;
    this._stopOnVisibilityChange = false;

    this._firstDate = 0;
    this.maxFrame = 1 / OMY_SETTING.RENDER_FPS;
    this.renderDelta = 0;

    this.stopOnVisibilityChange = true;
    this.startAnimate();
  }

  startAnimate() {
    if (!this.isRunning) {
      PIXI.spine.Spine.globalAutoUpdate = true;
      this.isRunning = true;
      if (this._firstDate === 0) this._firstDate = Date.now();
      this._ticker.start();
    }
  }

  stopAnimate() {
    if (this.isRunning) {
      PIXI.spine.Spine.globalAutoUpdate = false;
      this.isRunning = false;
      this._ticker.stop();
    }
  }

    _animate() {
        if (this.stage) {
            // this.renderDelta += this._ticker.deltaMS * 0.001;

            this._onPrerenderALoop();
            this.renderer.render(this.stage);
            /* if (this.renderDelta > this.maxFrame) {
               this.renderDelta -= this.maxFrame;
               this.renderer.render(this.stage);
             }*/
            this._onPostrenderALoop();
        }
    }

  _onVisibilityChange() {
    const isHide = !!(document.hidden || document.webkitHidden || document.mozHidden || document.msHidden);
    if (isHide) {
      this.stopAnimate();
    } else {
      this.startAnimate();
    }

    if (isHide) Omy.stage.on("tap", this._onVisibilityChange, this);
    else Omy.stage.off("tap", this._onVisibilityChange, this);

    this._onVisibilityALoop(isHide);
  }

  get realTime() {
    return this._firstDate > 0 ? (Date.now() - this._firstDate) / 1000 : 0;
  }

  get stopOnVisibilityChange() {
    return this._stopOnVisibilityChange;
  }

  set stopOnVisibilityChange(value) {
    if (value === this._stopOnVisibilityChange) return;
    this._stopOnVisibilityChange = value;
    const evt = getVisibilityChangeEvent();
    if (value) {
      document.addEventListener(evt, this._onVisibilityChange.bind(this));
    } else {
      document.removeEventListener(evt, this._onVisibilityChange.bind(this));
    }
  }

  render() {

  }

  _onPrerenderALoop() {
    if (this._stats)
      this._stats.begin();
  }

  _onPostrenderALoop() {
    Timer.timerManager.update(this._ticker.elapsedMS);
    Omy.keys.update();
    if (this._updateList.length) {
      for (let updateListElement of this._updateList)
        updateListElement.apply(null, updateListElement.methodParams);
      this._updateList.length = 0;
    }
    if (this._stats)
      this._stats.end();
  }

  _onVisibilityALoop(isHide) {
    if (isHide) {
      this._emit.emit("game_no_active");
    } else {
      this._emit.emit("game_active");
    }
    this.gamePaused = isHide;
  }

  addGameActive(func, context, once = false) {
    if (once)
      this._emit.once("game_active", func, context);
    else
      this._emit.on("game_active", func, context);
  }

  addGameNoActive(func, context, once = false) {
    if (once)
      this._emit.once("game_no_active", func, context);
    else
      this._emit.on("game_no_active", func, context);
  }

    updateRenderSetting() {
        this.maxFrame = 1 / OMY_SETTING.RENDER_FPS;
        this._ticker.maxFPS = OMY_SETTING.RENDER_FPS;
        this._ticker.minFPS = OMY_SETTING.RENDER_FPS;
    }

  removeGameActive(func, context) {
    this._emit.removeListener("game_active", func, context);
  }

  removeGameNoActive(func, context) {
    this._emit.removeListener("game_no_active", func, context);
  }

  /**
   * @param {Function}func
   * @param {Object}context
   * @param {Array}methodParams
   */
  addNextTickUpdate(func, context, methodParams = null) {
    methodParams = methodParams || [];
    func = func.bind(context);
    // methodParams.unshift(context);
    func.methodParams = methodParams;
    this._updateList.push(func);
  }

  get gamePaused() {
    return this._gamePaused;
  }

  set gamePaused(value) {
    this._gamePaused = value;
    if (this._gamePaused) {
      this._ticker.stop();
      this.stopAnimate();
      Omy.sound.pauseAll();
      Omy.keys.clear();
    } else {
      this._ticker.start();
      this.startAnimate();
      Omy.sound.resumeAll();
    }
  }

  get stats() {
    return this._stats;
  }

  get emit() {
    return this._emit;
  }
}

function getVisibilityChangeEvent() {
  if (typeof document.hidden !== "undefined") {
    return "visibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitvisibilitychange";
  } else if (typeof document.mozHidden !== "undefined") {
    return "mozvisibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    return "msvisibilitychange";
  }
}
